import { StyleSheet } from '@react-pdf/renderer';

/**
 * NOTE: `fontSize` values in this file intentionally use `px` (not `rem`).
 * These styles are consumed by @react-pdf/renderer, which produces a fixed-
 * dimension PDF document. PDF rendering does not honor the browser's root
 * font-size, so converting to `rem` for the project-wide a11y px→rem pass
 * would break PDF layout. This is the documented exception to that rule.
 */
export const styles = StyleSheet.create({
  itineraryImage: {
    height: 165,
    width: 240,
  },
  page: {
    fontSize: '8px',
    color: '#000033',
    backgroundColor: '#fff',
    paddingTop: 8,
    paddingHorizontal: 14,
    paddingBottom: 132,
  },
  pageContent: {
    padding: '8px',
    paddingBottom: 24,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    marginTop: 0,
    marginRight: 0,
    marginBottom: 12,
    marginLeft: 0,
    backgroundColor: '#010033',
  },
  title: {
    fontSize: '16px',
  },
  heading: {
    fontSize: '12px',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textBold: {
    fontWeight: 700,
    fontSize: 14,
  },
  spaceY: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  billTo: {
    marginBottom: '10px',
  },
  table: {
    width: '100%',
    borderColor: '1px solid #f3f4f6',
    margin: '20px 0',
  },
  tableHeader: {
    backgroundColor: '#e5e5e5',
  },
  td: {
    padding: '6px',
  },
  totals: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  seasun: {
    backgroundColor: 'yellow',
  },
  centerText: {
    textAlign: 'center',
  },
  footer: {
    padding: '8px 14px',
    width: '100%',
    minHeight: 52,
    display: 'flex',
    alignItems: 'flex-start',
    fontSize: '8px',
    color: '#ffffff',
    backgroundColor: '#000033',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
  },
  footerCopyrightText: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    margin: '0 auto',
    textAlign: 'center',
  },
  timeDocWasGeneratedText: {
    margin: '2px 0 0 auto',
    fontStyle: 'italic',
  },
  categorySection: {
    paddingTop: '20px',
    paddingHorizontal: '6px',
  },
  categorySectionCard: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '6px',
  },
  categorySectionCardCategoryTitle: {
    flex: 1,
    padding: '6px',
    color: 'white',
    fontSize: '7px',
  },
  categorySectionCardCategoryDescription: {
    flex: 3,
    backgroundColor: 'white',
    padding: '6px',
    justifyContent: 'center',
    height: '85%',
    marginRight: 2,
  },
  categorySectionCardCategoryDescriptionText: {
    color: '#333',
    fontSize: '7px',
    paddingHorizontal: 2,
  },
  keyImage: {
    width: '100%',
    aspectRatio: 16 / 8,
  },
  keySymbolsContainer: {
    alignSelf: 'center',
  },

  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '6px',
    marginBottom: '6px',
  },
  fullItineraryCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '6px',
    marginBottom: '42px',
  },
  cardTitleContainer: {
    minHeight: '34px',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: '8px',
    marginBottom: '5px',
  },
  fullItineraryCategoryTitleContainer: {
    minHeight: '34px',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: '8px',
    marginTop: '34px',
    marginBottom: '16px',
  },
  cardTitle: {
    fontSize: '8px',
    fontWeight: 700,
    color: 'white',
    textAlign: 'center',
  },
  cardHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 6,
    paddingTop: '2px',
    minHeight: 64,
    marginBottom: '6px',
  },
  cardHeaderContainerNoImage: {
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    paddingTop: '2px',
    height: 'auto',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginBottom: '4px',
  },
  cardHeaderImage: {
    minWidth: 102,
    minHeight: 62,
    width: 102,
    height: 62,
  },
  cardHeaderInformationContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    flex: 1,
  },
  cardHeaderInformationContainerNoImage: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  cardHeaderInformationTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  cardHeaderInformationTitleText: {
    fontSize: '9px',
    fontWeight: 700,
  },
  cardHeaderInformationCode: {
    fontSize: '6px',
    color: '#3d3d55',
  },
  cardHeaderIconsContainer: {
    padding: '6px 0 0 0',
    display: 'flex',
    flexDirection: 'row',
    fontSize: '8px',
    gap: 6,
    alignItems: 'center',
  },
  cardHeaderIconsContainerNoImage: {
    padding: '6px 0 0 0',
    display: 'flex',
    flexDirection: 'row',
    fontSize: '8px',
    gap: 6,
    alignItems: 'center',
  },
  cardHeaderIconsContainerDurationIcon: {
    height: '16px',
    width: '16px',
  },
  cardHeaderIconsDurationContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeaderIconsDurationLabel: {
    fontSize: '8px',
    fontWeight: 700,
  },
  cardHeaderIconsDurationValue: {
    fontSize: '8px',
    marginTop: 1,
  },
  cardIconsContainer: {
    minHeight: 24,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  cardBodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 4,
    gap: 4,
  },
  cardBodyLongDescriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    marginBottom: 10,
  },
  cardBodyParagraph: {
    marginBottom: 0,
  },
  cardBodyLongDescription: {
    fontSize: '7px',
    lineHeight: 1.45,
    padding: '0 0 1px 0',
  },
  cardBodyPerPersonContainer: {
    paddingTop: 12,
  },
  cardBodyPerPersonLabel: {
    fontSize: '7px',
    fontWeight: 700,
    marginTop: 0,
  },
  cardBodyPricesContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 8,
    paddingBottom: 10,
    gap: 4,
  },
  cardBodyPriceLine: {
    fontSize: '7px',
    fontWeight: 400,
  },
  cardBodyMinimumParticipants: {
    fontSize: '7px',
    marginTop: 6,
    marginBottom: 4,
  },
  cardBodyLanguageContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  cardBodyLanguageLabel: {
    fontSize: '7px',
    fontWeight: 700,
    padding: '0',
  },
  cardBodyLanguageValues: {
    fontSize: '7px',
    padding: '0',
  },
  cardBodyFooter: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 0,
    marginTop: 0,
    marginBottom: 8,
  },
  cardBottomDivider: {
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
    marginTop: 6,
  },
  allItineraryContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 20,
    padding: '8px 0 28px 0',
  },
  allItineraryContainerNoMap: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '8px 0 28px 0',
  },
  allItineraryContainerInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  allItineraryContainerInfoRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 0',
    fontSize: '14px',
    flexWrap: 'wrap',
  },
  allItineraryFullContainer: {
    padding: '0 2px',
  },
  allItineraryDescription: {
    padding: '10px 0 0 0',
  },
  allItineraryItineraries: {
    fontWeight: 600,
    flexWrap: 'wrap',
    minWidth: '200px',
    maxWidth: '200px',
  },
  allItineraryContainerInfoColumn: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0',
    fontSize: '14px',
  },
  cardHeaderClock: {
    backgroundColor: 'red',
    width: 20,
    height: 20,
    padding: 10,
  },
  allItineraryDayContainer: {
    padding: '30px 0 16px 0',
    textAlign: 'center',
  },
  allItineraryDayContainerTitle: {
    fontSize: 24,
    fontWeight: 700,
  },
  allItineraryDayContainerDate: {
    fontSize: 8,
    padding: '8px 0 0 0',
  },
  allItinerarycardBodyLongDescription: {
    fontSize: 8,
  },
  allItinerarycardBoldText: {
    fontSize: 8,
    fontWeight: 600,
  },
  tableContainer: {
    paddingTop: 4,
    width: '58%',
  },
  tableContainerNoMap: {
    paddingTop: 4,
    width: '100%',
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 4,
  },
  tableLabel: {
    width: 108,
    textAlign: 'right',
    padding: '0 8px 0 0',
    fontSize: '11px',
  },
  tableValue: {
    flex: 1,
    fontWeight: 700,
    fontSize: '11px',
  },
  footerDescription: {
    fontSize: 8,
  },
  footerDescriptionContainer: {
    padding: '8px 0',
  },
  IconImage: {
    width: 20,
    height: 20,
    margin: 0,
  },
  metaRowsContainer: {
    fontSize: '8px',
    marginBottom: 8,
  },
  metaRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '3px',
    marginBottom: 2,
  },
  metaRowValue: {
    fontWeight: 700,
  },
  byDayTitleContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 14,
  },
  byDayTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: '#000033',
    textAlign: 'center',
  },
});
